import { createReducer } from '../../utilities';
import {
    FAIL_FETCH_STATS_NEW_USERS_FUNNEL,
    REQUEST_FETCH_STATS_NEW_USERS_FUNNEL,
    SUCCESS_FETCH_STATS_NEW_USERS_FUNNEL
} from "../../../actions/entities/statistics/newUsersFunnel";


const initialState = {
    data: null,
    error: false,
    isFetching: false,
};

function requestFetch(state) {
    return {
        ...state,
        isFetching: true,
    };
}

function successFetch(state, action) {
    const { data } = action;
    return {
        ...state,
        data,
        isFetching: false,
    };
}

function failFetch(state, action) {
    const { error } = action;
    return {
        ...state,
        isFetching: false,
        error
    };
}

export default createReducer(initialState, {
    [REQUEST_FETCH_STATS_NEW_USERS_FUNNEL]: requestFetch,
    [SUCCESS_FETCH_STATS_NEW_USERS_FUNNEL]: successFetch,
    [FAIL_FETCH_STATS_NEW_USERS_FUNNEL]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/newUsersFunnel.js